export const testimonials = [
  {
    id: 1,
    rating: 5,
    text: "All in one and amazing tool. I was watching KiteKraken AI videos on YouTube and Instagram about 3 months. I started today by purchasing 3 months account. I'm completely zero on trading markets. Today's results was amazing for me 👉4 trades 4 wins! Thanks KiteKraken AI community for their hardworking and honesty",
    author: "Michael Chen",
    date: "2 weeks ago"
  },
  {
    id: 2,
    rating: 5,
    text: "5 days in and I'm already seeing profit! I've been trading since 2019 but in and out of groups as they were more focused on recruiting instead of helping the traders... KiteKraken AI focuses on indicators to help read the charts for better analyzing...",
    author: "Sarah Johnson",
    date: "1 month ago"
  },
  {
    id: 3,
    rating: 5,
    text: "My trading journey started the hard way; I made all the mistakes a new trader could possibly make, and blew 2 accounts due to my lack of knowledge and experience. After trying more indicators than I can remember, I was fortunate to find KiteKraken AI. This is an end-to-end all-round amazing tool...",
    author: "David Martinez",
    date: "3 weeks ago"
  },
  {
    id: 4,
    rating: 5,
    text: "KiteKraken AI is a good machine learning algorithm that shows the best buys and the best sells. I made profit in the last 2 weeks. They also give us access to 32 analytics over all markets and signals from 20 different analysts.",
    author: "Emma Wilson",
    date: "2 months ago"
  },
  {
    id: 5,
    rating: 5,
    text: "This indicator is like a light shining in the darkness. For most it can be very challenging to trade on the market. This indicator has helped me focus on my take profits and stop loss management with a more disciplined, risk-managed approach.",
    author: "James Anderson",
    date: "1 month ago"
  },
  {
    id: 6,
    rating: 5,
    text: "I saw videos on YouTube and got interested. The Telegram channel provides valuable market insights and analysis from 20+ experienced analysts. It's a helpful resource for learning trading strategies.",
    author: "Lisa Thompson",
    date: "3 weeks ago"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How do I get access after purchasing?",
    answer: "Once you have decided on a plan, you'll get access to all KiteKraken AI indicators within 8 hours. After you receive your activation email, you can find the indicators in your TradingView account under 'invite-only' scripts. You don't necessarily need a paid TradingView plan, because our indicators also work with the free TradingView plan. In addition, you get access to our VIP members area and our VIP signals area in our Telegram server. You will also receive the instructions VIA email. Get setup ideas, learn new strategies, and see settings from other members in the VIP areas."
  },
  {
    id: 2,
    question: "What markets does KiteKraken AI work on?",
    answer: "KiteKraken AI works on any international market including stocks, options, indices, forex trading, futures, and commodities. KiteKraken AI works on ALL timeframes available on the TradingView charting platform. You can utilize KiteKraken AI for scalping, swing-trading, and intraday trading. KiteKraken AI also comes included with several built-in features such as take profit and stop loss suggestions, auto-support and resistance, informational dashboard and more. You can add KiteKraken AI to your current trading strategy to provide strong confirmation and improve your win-rate."
  },
  {
    id: 3,
    question: "Do the signals repaint?",
    answer: "KiteKraken AI signals do not repaint. Repainting is when a signal may appear and then move around or disappear a few days later. This is commonly found in poorly coded scripts."
  },
  {
    id: 4,
    question: "Is it beginner friendly?",
    answer: "Yes. KiteKraken AI is beginner friendly. KiteKraken AI comes included with a course that teaches you how to set it up and use it properly, including all of its features. Often beginners make the mistake of entering against the trend. KiteKraken AI helps you trade with the trend. You can find tutorials in our Telegram group and in case you need help our support will always be there for you."
  },
  {
    id: 5,
    question: "What are the pricing options?",
    answer: "We offer all-inclusive memberships starting at $67/mo. You can save on your membership by getting the yearly or lifetime plans."
  },
  {
    id: 6,
    question: "What kind of support do you offer?",
    answer: "We provide world-class 24/7 support VIA email & from within our Telegram group – you will not be left unanswered. You can also use the live chat on our website."
  },
  {
    id: 7,
    question: "Does it work on mobile?",
    answer: "Yes, KiteKraken AI works on the TradingView website and on the TradingView App. It's supported for Android and iOS."
  },
  {
    id: 8,
    question: "Are there video tutorials?",
    answer: "Yes! When you sign up for KiteKraken AI you will receive an email with video tutorials! Tutorials are also available in the header of our website and in our Telegram server!"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "30-Day Access",
    price: 99,
    originalPrice: 299,
    duration: "30 days",
    description: "Full access for 30 days",
    features: [
      "All KiteKraken AI indicators",
      "VIP Telegram access",
      "24/7 support",
      "Real-time alerts",
      "Video tutorials"
    ],
    popular: false
  },
  {
    id: 2,
    name: "180-Day Access",
    price: 499,
    originalPrice: 799,
    duration: "6 months",
    description: "6 months of full access",
    features: [
      "All KiteKraken AI indicators",
      "VIP Telegram access",
      "24/7 support",
      "Real-time alerts",
      "Video tutorials",
      "Priority support"
    ],
    popular: true,
    badge: "Most Popular"
  },
  {
    id: 3,
    name: "365-Day Access",
    price: 999,
    originalPrice: 1499,
    duration: "1 year",
    description: "Full access for 1 year",
    features: [
      "All KiteKraken AI indicators",
      "VIP Telegram access",
      "24/7 support",
      "Real-time alerts",
      "Video tutorials",
      "Priority support",
      "Exclusive webinars"
    ],
    popular: false,
    badge: "Best Value"
  }
];

export const tutorials = [
  {
    id: 1,
    title: "Getting Started with KiteKraken AI",
    description: "Learn the basics of setting up and using KiteKraken AI for the first time",
    duration: "10 min",
    category: "Beginner"
  },
  {
    id: 2,
    title: "TradingView Setup Guide",
    description: "Complete guide to integrating KiteKraken AI with your TradingView account",
    duration: "15 min",
    category: "Setup"
  }
];
